module.exports = __webpack_public_path__ + "static/finish-db67e96885eeb47396c7494886f7f1d4.jpg";